<!-- 标单制定 -->
<div class="main" *ngIf="makeBidStatus">
  <div class="title">
    <h4>{{ 'BidCreat.BidCreating' | translate }}</h4>
    <em nz-icon nzType="edit" nzTheme="outline" (click)="isVisible = !isVisible"></em>
  </div>
  <!-- isVisible:是否显示标单编辑页面 -->
  <div class="bid" *ngIf="isVisible">
    <ng-container>
      <!-- button -->
      <div class="btn-group2" *ngIf="makeBidEditStatus">
        <button nz-button nzType="primary" (click)="downloadBid()">{{ 'BidCreat.Download' | translate }}</button>
        <button nz-button nzType="primary" (click)="saveBid()">{{ 'BidCreat.Save' | translate }}</button>
      </div>
      <!-- 标单内容 -->
      <div class="bid-content" id="bidContent">
        <!-- 标单头部:title button -->
        <div class="bid-head">
          <h3>{{ 'BidCreat.Bid' | translate }}</h3>
        </div>
          <!-- 标单form -->
          <app-bid-form 
            [makeBidEditStatus]="makeBidEditStatus"
            [formContent]="formContent" 
            [bidBaseInfor]="bidSaveData['bidBaseInfor']"
            (projectNameChanged)="projectNameChanged($event)"
          >
          </app-bid-form>

          <!-- 标单second-content :table-->
          <app-bid-table 
            [makeBidEditStatus]="makeBidEditStatus"
            [listOfTable1Data]="listOfTable1Data"
            [listOfBaseMaterialData]="listOfBaseMaterialData"
            [selectColumns]="selectColumns"
            [table2Columns]="table2Columns"
            [bidBaseInfor]="bidSaveData['bidBaseInfor']"
            (itemChange)="itemChange($event)"
            (selectValueChange)="selectValueChange($event)" 
            (table1RemarkChanged)="table1RemarkChanged($event)"
            (table1ScaleChanged)="table1ScaleChanged($event)"
            (remarkSelectChange)="remarkSelectChange($event)"
            (addRow)="addRow($event)" 
            (delRow)="delRow($event)" 
            (addList)="addList($event)" 
            (delList)="delList($event)" 
          >
          </app-bid-table>
      </div>
    </ng-container>
  </div>
</div>